module.exports = __webpack_public_path__ + "img/payment-promotion.1f6c47a.png";